import {
	FormControl,
	FormLabel,
	Heading,
	Input,
	Stack,
	ThemeSpaceVariable,
} from "@caspeco/casper-ui-library";
import { useUserContext } from "../../hooks/use-user-context";
import { useEffect, useState } from "react";
import { isNullOrWhiteSpace } from "../../utils/string-helper";
import { PostLoginOnboardingStepsProps } from "./post-login-onboarding";
import { useTranslation } from "react-i18next";
import { useUpdateUserQuery } from "../../hooks/use-update-user-query";
import { personalInfoSchema } from "../../models/user";

export const PostLoginOnboardningName = ({ setContinueButton }: PostLoginOnboardingStepsProps) => {
	const { user } = useUserContext();
	const { t } = useTranslation();
	const { saveUserAsync } = useUpdateUserQuery(personalInfoSchema.pick({ firstname: true, lastname: true }));

	const [firstName, setFirstName] = useState(user?.firstname);
	const [firstNameInvalid, setFirstNameInvalid] = useState(false);
	const [lastName, setLastName] = useState(user?.lastname);
	const [lastNameInvalid, setLastNameInvalid] = useState(false);

	useEffect(() => {
		const save = async () => {
			const haveChanges = firstName !== user?.firstname || lastName !== user?.lastname;

			if (haveChanges) {
				return await saveUserAsync({
					firstname: firstName,
					lastname: lastName,
				});
			} else {
				return true;
			}
		};

		setContinueButton({
			isDisabled: isNullOrWhiteSpace(firstName) || isNullOrWhiteSpace(lastName),
			save: save,
		});
	}, [firstName, lastName, saveUserAsync, setContinueButton, user]);

	return (
		<Stack gap={ThemeSpaceVariable.Large}>
			<Heading as="h1">{t("post_login_onboarding_name_title")}</Heading>
			<Stack gap={ThemeSpaceVariable.Medium}>
				<FormControl isInvalid={firstNameInvalid} isRequired>
					<FormLabel>{t(`profile_firstname`)}</FormLabel>
					<Input
						value={firstName}
						onChange={(e) => setFirstName(e.target.value)}
						onBlur={(e) => setFirstNameInvalid(isNullOrWhiteSpace(e.target.value))}
						size={"lg"}
					></Input>
				</FormControl>
				<FormControl isInvalid={lastNameInvalid} isRequired>
					<FormLabel>{t(`profile_lastname`)}</FormLabel>
					<Input
						value={lastName}
						onChange={(e) => setLastName(e.target.value)}
						onBlur={(e) => setLastNameInvalid(isNullOrWhiteSpace(e.target.value))}
						size={"lg"}
					></Input>
				</FormControl>
			</Stack>
		</Stack>
	);
};
